function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M230 282v205c0 13 12 25 26 25s26-11 26-25V282h205c13 0 25-12 25-26s-11-26-25-26H282V25c0-13-12-25-26-25s-26 11-26 25v205H25c-13 0-25 12-25 26s11 26 25 26z"
});

function SvgCreateNewPost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "create-new-post_svg__icon",
    viewBox: "0 0 512 512",
    height: "1em",
    width: "1em",
    fill: "currentColor"
  }, props), _ref);
}

export default __webpack_public_path__ + "create-new-post-275cfbe6ebaccc615791c22704c43e0a.svg";
export { SvgCreateNewPost as ReactComponent };